import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  AfterViewInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { asWordList } from './helpers';
import wordCloud, { WordCloudWord } from './generate-word-cloud';

@Component({
  selector: 'qa-word-cloud-visualization',
  templateUrl: './word-cloud-visualization.component.html',
  styleUrls: ['./word-cloud-visualization.component.scss'],
})
export class WordCloudVisualizationComponent
  implements AfterViewInit, OnChanges
{
  @ViewChild('wordCloud') wordCloudContainer: ElementRef<HTMLDivElement>;

  @Input() words: string[];

  private wordList: WordCloudWord[];

  private cloudRef;

  constructor() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cloudRef = wordCloud(this.wordCloudContainer.nativeElement);

      this.buildWordCloud(this.words);
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      JSON.stringify(changes.words.currentValue) !==
      JSON.stringify(changes.words.previousValue)
    ) {
      this.buildWordCloud(changes.words.currentValue);
    }
  }

  buildWordCloud(words: string[]) {
    if (!this.wordCloudContainer?.nativeElement) {
      return;
    }
    const rect = this.wordCloudContainer?.nativeElement.getBoundingClientRect();
    const list = asWordList(words, rect.width, rect.height);
    this.wordList = list;
    this.drawCloud();
  }

  private drawCloud() {
    if (!this.wordList?.length || !this.cloudRef) {
      return;
    }
    this.cloudRef.update(_.cloneDeep(this.wordList));
  }
}
